export default (that) => [
  {
    text: that.$l('INDEX.btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ hxSkuStatus, applicationStatus }) => {
      return !!(
        ['D'].includes(hxSkuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ hxSkuStatus, applicationStatus }) => {
      return !!(
        ['Y', 'D'].includes(hxSkuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_full_member') || '转正产品',
    icon: 'el-icon-circle-check',
    menuType: 'fullMember',
    allow: 'F',
    divided: true,
    disabled: ({ hxSkuStatus }) => !['Q'].includes(hxSkuStatus),
  },
  {
    text: that.$l('INDEX.btn_print_tag') || '标签打印',
    icon: 'el-icon-printer',
    menuType: 'print',
    divided: true,
    allow: 'P',
    disabled: ({ hxSkuStatus }) => !['Y'].includes(hxSkuStatus),
  },
]
